import { showSuccessToast } from 'app/components/ShowToast'
import ExcelJS from 'exceljs'
import {saveAs} from 'file-saver'

function stripHtmlTags(str) {
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}

export const ExportControls = async (activeFrameworks, controls) => {
  for (const framework of activeFrameworks) {
    const filteredControls = controls.filter((control) => {
      if (control.author === 'Custom Control') {
        if (!control.control_framework_mappings) return false
        return control.control_framework_mappings.startsWith(framework)
      }
      
      if (!control.control_framework_mappings) return false
      return (
        control.control_framework_mappings.startsWith(framework) &&
        !control.control_framework_mappings.startsWith('ISO 27001:2013')
      )
    }).sort((a, b) => {
      const titleA = (a.control_title || '').toLowerCase().trim()
      const titleB = (b.control_title || '').toLowerCase().trim()
      
      if (titleA !== titleB) {
        return titleA.localeCompare(titleB)
      }
    })

    if (filteredControls.length > 0) {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Controls')

      worksheet.views = [{state: 'frozen', ySplit: 1}]

      worksheet.columns = [
        {header: 'Control', key: 'controlObjective', width: 40},
        {header: 'Control Description', key: 'controlDescription', width: 60},
        {header: 'Category', key: 'clause', width: 30},
        {header: 'Framework', key: 'sec', width: 40},
        {header: 'Author', key: 'author', width: 20},
        {header: 'Platform', key: 'platform', width: 15},
        {header: 'Document', key: 'document', width: 15},
        {header: 'Status', key: 'status', width: 15},
        {header: 'Justification for exclusion', key: 'justification', width: 40},
      ]

      const headerRow = worksheet.getRow(1)
      headerRow.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 10}
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF000000'},
      }
      headerRow.height = 30
      headerRow.alignment = {horizontal: 'center'}

      for (let i = 1; i <= 11; i++) {
        const cell = headerRow.getCell(i)
        cell.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 11}
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'FF000000'},
        }
        cell.alignment = {horizontal: 'center', vertical: 'middle'}
      }

      const exportData = filteredControls.map((row) => ({
        controlObjective: row.control_title || '',
        controlDescription: stripHtmlTags(row.control_description) || '',
        clause: row.control_category,
        sec: row.control_framework_mappings || '',
        author: row.author || 'SecureSlate',
        platform: row.control_test || '',
        document: row.control_document || '',
        status: row.control_evidence_status || '',
        justification: row.deactivation_control || '',
      }))

      exportData.forEach((item) => {
        const row = worksheet.addRow(item)
        row.height = 20
        row.font = {size: 10}

        if (item.status === 'Deactivated') {
          row.eachCell((cell) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {argb: 'DDEEFF'},
            }
          })
        }

        if (item.status === 'OK') {
          row.getCell('H').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'D9EAD3'},
          }
        } else if (item.status === 'Unhealthy') {
          row.getCell('H').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F4CCCC'},
          }
        }
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const excelBlob = new Blob([buffer], {type: 'application/octet-stream'})

      saveAs(excelBlob, `controls_${framework}.xlsx`)
      showSuccessToast({message: 'Controls data exported successfully'})
    }
  }
}